import React, { useContext } from 'react';
import { notificationContext } from '../../context/notificationContext';
import Checkmark from '../../assets/images/icons/notification-checkmark.svg';
import Error from '../../assets/images/icons/error.svg';
import Styles from './NotificationBadge.module.scss';

const NotificationBadge = () => {
  const { notificationState, notificationDispatch } = useContext(notificationContext);
  const { isOpen, message, icon } = notificationState;

  const iconMap = {
    checkmark: Checkmark,
    error: Error,
  };

  if (!isOpen) {
    return false;
  }

  return (
    <div
      className={Styles.notificationBadge}
      onClick={() => {
        notificationDispatch({
          type: 'SET_NOTIFICATION',
          isOpen: false,
          message: null,
          icon: null,
          addedClubSerial: null,
        });
      }}
    >
      <div className={Styles.message}>
        {iconMap[icon] && (
          <img
            className={Styles.notificationIcon}
            src={iconMap[icon]} alt='icon'
          />
        )}
        {message}
      </div>
    </div>
  );
};

export default NotificationBadge;
